











































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ProductoAmazon } from "@/shared/dtos/productosAmazon/ProductoAmazon";
import { RouterNames } from "@/router/routernames";
import { UtilsString } from "@/utils/utils-string";
import { ssmTokenService } from "@/shared/services/token-service";
import { medicalUserService } from "@/shared/services/user-service";
import { ProcessoNums } from "../procesos/ProcessoNums";
import TiendaOnlineClientesModule from "@/store/modules/TiendaOnlineClientes-module";
import tienda_cart_module from "@/store/modules/tienda_cart_module";

@Component({
  components: {},
})
export default class productos_scroll_infinito extends Vue {
  selectedProcessoNum: number | null = 0;
  searchQueryExecute: string = "";
  tags: { id: number; text: string }[] = [
    {
      id: 100,
      text: "Todos",
    },
    {
      id: ProcessoNums.Disponible,
      text: "Disponible",
    },
    { id: ProcessoNums.Reservado, text: "Reservado" },
    { id: ProcessoNums.VendidoEfectivo, text: "Vendido" },
    { id: ProcessoNums.Devolucion, text: "Devolución" },
    { id: ProcessoNums.MermaRoto, text: "MermaRoto" },
    { id: ProcessoNums.Envio, text: "Envio" },
    { id: ProcessoNums.PendientePago, text: "PendientePago" },
    { id: ProcessoNums.Reparacion, text: "Reparacion" },
  ];
  productsPerPage = 20;
  currentPage = 1;
  isLoadingMore = false;
  isInitialLoading = false;
  loadingMessage = "Buscando los mejores precios...";
  loadingTimer: any = null;

  async created() {
    if (this.$route.query.search) {
      TiendaOnlineClientesModule.SetSearchQuery(
        UtilsString.ValueOf(this.$route.query.search)
      );
    }

    await this.CargaNormal();
  }

  destroyed() {
    if (this.loadingTimer) {
      clearInterval(this.loadingTimer);
    }
  }

  async CargaNormal() {
    const hasSearch = !!TiendaOnlineClientesModule.searchQuery;
    if (TiendaOnlineClientesModule.TiendaOnlineClienteses.length === 0 || hasSearch) {
      this.isInitialLoading = true;
      const messages = [
        "Buscando los mejores precios...",
        "Cargando descuentos exclusivos...",
        "Preparando tu experiencia de compra...",
        "Encontrando artículos únicos...",
        "Calculando el ahorro real...",
        "Reuniendo las mejores ofertas...",
      ];
      let msgIndex = 0;
      this.loadingMessage = messages[0];
      this.loadingTimer = setInterval(() => {
        msgIndex = (msgIndex + 1) % messages.length;
        this.loadingMessage = messages[msgIndex];
      }, 1200);

      try {
        if (ssmTokenService.hasToken() && medicalUserService.hasuser()) {
          await TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacion({
            skip: 0,
            take: this.productsPerPage,
            selectedProcessoNumber: this.selectedProcessoNum || 0,
            search: this.searchQuery,
          });
        } else {
          this.selectedProcessoNum = ProcessoNums.Disponible;
          await TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacion({
            skip: 0,
            take: this.productsPerPage,
            selectedProcessoNumber: this.selectedProcessoNum,
            search: this.searchQuery,
          });
        }
      } finally {
        clearInterval(this.loadingTimer);
        this.loadingTimer = null;
        this.isInitialLoading = false;
      }
    }
  }

  async loadMore() {
    if (this.isLoadingMore) return;
    this.isLoadingMore = true;
    try {
      const skip = this.products.length; // ya cargados
      const take = this.productsPerPage; // EXACT take to match display
      const nuevos =
        await TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacionSinAction(
          {
            skip: skip,
            take: take,
            selectedProcessoNumber: this.selectedProcessoNum || 0,
            search: this.searchQuery,
          }
        );

      TiendaOnlineClientesModule.onGetTiendaOnlineClientesesPaginacionNuevosADD(
        nuevos
      );
    } finally {
      this.isLoadingMore = false;
    }
  }

  mounted() {
    const hasSearch = !!TiendaOnlineClientesModule.searchQuery;
    const savedProducts = TiendaOnlineClientesModule.TiendaProductosCahe;
    const savedPage = localStorage.getItem("currentPage");

    if (!hasSearch && savedProducts && TiendaOnlineClientesModule.TiendaProductosCahe.length) {
      const prevTotal = TiendaOnlineClientesModule.totalProductos;
      TiendaOnlineClientesModule.onGetTiendaOnlineClienteses([]);
      var products = TiendaOnlineClientesModule.TiendaProductosCahe;
      TiendaOnlineClientesModule.onGetTiendaOnlineClientesesPaginacionNuevosADD(
        { Productos: products, Total: prevTotal || products.length }
      );
      localStorage.removeItem("currentPage");
    }

    if (savedPage && !hasSearch) {
      this.currentPage = parseInt(savedPage);
    }

    const savedScrollPosition = localStorage.getItem("scrollPosition");
    if (savedScrollPosition && !hasSearch) {
      setTimeout(() => {
        window.scrollTo({ top: parseInt(savedScrollPosition), behavior: 'auto' });
      }, 150);
    }
  }

  get paginatedProducts() {
    return this.filteredProducts.slice(
      0,
      this.currentPage * this.productsPerPage
    );
  }
  get canLoadMore() {
    return this.totalProductos > this.paginatedProducts.length;
  }
  delay(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  onIntersect(entries: any) {
    const entry = entries[0];
    if (entry.isIntersecting && this.canLoadMore && !this.isLoadingMore) {
      this.currentPage++;
      this.loadMore();
    }
  }

  visitar_producto(Producto: ProductoAmazon) {
    // Guardamos la posición del scroll antes de navegar
    localStorage.setItem("scrollPosition", window.scrollY.toString());
    // Guardamos el estado de los productos y la página en localStorage
    TiendaOnlineClientesModule.onSetCache(this.products);
    localStorage.setItem("currentPage", JSON.stringify(this.currentPage));

    // Determinar flag mayorista desde la ruta actual
    var mayorista = false;
    if (
      this.$route &&
      this.$route.meta &&
      typeof this.$route.meta.mayorista !== "undefined"
    ) {
      mayorista = this.$route.meta.mayorista === true;
    }

    // Navegar pasando el flag por query (m=1/0)
    this.$router
      .push({
        name: RouterNames.tienda_producto,
        params: {
          id: UtilsString.ValueOf((Producto as any).id),
        },
        query: {
          m: mayorista ? "1" : "0",
        },
      })
      .catch(function () {
        /* noop */
      });
  }
  get esta_logeado() {
    return ssmTokenService.hasToken() && medicalUserService.hasuser();
  }
  get products() {
    return TiendaOnlineClientesModule.TiendaOnlineClienteses;
  }
  get searchQuery() {
    this.searchQueryExecute = TiendaOnlineClientesModule.searchQuery;
    return TiendaOnlineClientesModule.searchQuery;
  }
  get filteredProducts() {
    if (!this.searchQuery) return this.products;
    const query = this.searchQuery.toLowerCase();
    return this.products.filter(
      (product) =>
        (product.titulo_producto && product.titulo_producto.toLowerCase().includes(query)) ||
        (product.asin && product.asin.toLowerCase().includes(query)) ||
        (product.lpn && product.lpn.toLowerCase().includes(query)) ||
        (product.localizacion && product.localizacion.toLowerCase().includes(query)) ||
        String(product.id).includes(query)
    );
  }
  get totalProductos() {
    return TiendaOnlineClientesModule.totalProductos; // Asegúrate de que esta propiedad esté almacenada correctamente
  }
  clearSearch() {
    TiendaOnlineClientesModule.SetSearchQuery("");
  }

  async handleProcessoNumChange() {
    await TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacion({
      skip: 0,
      take: this.productsPerPage,
      selectedProcessoNumber: this.selectedProcessoNum || 0,
      search: this.searchQuery,
    });
    if (this.selectedProcessoNum !== null) {
      switch (this.selectedProcessoNum) {
        case ProcessoNums.Disponible:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) =>
              product.estado === ProcessoNums.Disponible &&
              product.vendido === false
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.Reservado:
          var lista = this.paginatedProducts.filter(
            (product) => product.estado === ProcessoNums.Reservado
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.VendidoEfectivo:
        case ProcessoNums.VendidoTarjeta:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.vendido === true
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.Devolucion:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.estado === ProcessoNums.Devolucion
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.MermaRoto:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.estado === ProcessoNums.MermaRoto
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.Envio:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.estado === ProcessoNums.Envio
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.PendientePago:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.estado === ProcessoNums.PendientePago
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
        case ProcessoNums.Reparacion:
          var lista = TiendaOnlineClientesModule.TiendaOnlineClienteses.filter(
            (product) => product.estado === ProcessoNums.Reparacion
          );
          TiendaOnlineClientesModule.onGetTiendaOnlineClienteses(lista);
          break;
      }
    }
  }
  add_to_cart(product: ProductoAmazon) {
    tienda_cart_module.addProductToCart(product);
  }

  // === Lógica del botón ===
  public toggleCart(product: ProductoAmazon, event?: MouseEvent): void {
    if (this.isInCart(product)) {
      this.removeFromCart(product);
    } else {
      this.add_to_cart(product);
      if (event) {
        this.animateFlyToCart(event);
      }
    }
  }

  private animateFlyToCart(event: MouseEvent) {
    const card = (event.target as HTMLElement).closest('.premium-card');
    if (!card) return;
    
    const imgEl = card.querySelector('.product-image') as HTMLImageElement;
    if (!imgEl) return;
    
    const cartIcon = document.getElementById('header-cart-btn');
    if (!cartIcon) return;
    
    const imgRect = imgEl.getBoundingClientRect();
    const cartRect = cartIcon.getBoundingClientRect();
    
    const wrapper = document.createElement('div');
    wrapper.style.position = 'fixed';
    wrapper.style.top = imgRect.top + 'px';
    wrapper.style.left = imgRect.left + 'px';
    wrapper.style.width = imgRect.width + 'px';
    wrapper.style.height = imgRect.height + 'px';
    wrapper.style.zIndex = '99999';
    wrapper.style.transition = 'transform 1.2s cubic-bezier(0.25, 0.1, 0.25, 1), opacity 1.2s ease, border-radius 1.2s ease, box-shadow 1.2s ease';
    wrapper.style.borderRadius = '12px';
    wrapper.style.boxShadow = '0 10px 30px rgba(0,0,0,0.1)';
    wrapper.style.border = '2px solid transparent';
    wrapper.style.backgroundColor = '#ffffff';
    wrapper.style.overflow = 'hidden';
    wrapper.style.transformOrigin = 'top left';

    const flyingImg = document.createElement('img');
    flyingImg.src = imgEl.src;
    flyingImg.style.width = '100%';
    flyingImg.style.height = '100%';
    flyingImg.style.objectFit = 'contain';
    
    wrapper.appendChild(flyingImg);
    document.body.appendChild(wrapper);
    
    // Forzar reflow
    void wrapper.offsetWidth;
    
    const targetSize = 40;
    const scaleFactor = targetSize / imgRect.width;
    const deltaX = cartRect.left - imgRect.left + 4;
    const deltaY = cartRect.top - imgRect.top + 4;
    
    // Mover hacia el icono con efecto glowing
    wrapper.style.transform = `translate(${deltaX}px, ${deltaY}px) scale(${scaleFactor}) rotate(10deg)`;
    wrapper.style.opacity = '0.6';
    wrapper.style.borderRadius = '50%';
    wrapper.style.border = '10px solid #2ecc71';
    wrapper.style.boxShadow = '0 20px 40px rgba(46, 204, 113, 0.9)';
    
    setTimeout(() => {
      wrapper.remove();
      window.dispatchEvent(new CustomEvent("cart-added"));
    }, 1200); // 1.2s duration
  }

  public removeFromCart(product: ProductoAmazon): void {
    tienda_cart_module.removeFromCart(product.id);
  }

  public isInCart(product: ProductoAmazon): boolean {
    var cart = tienda_cart_module.carritoCompra;
    for (var i = 0; i < cart.length; i++) {
      if ((cart[i] as any).id === product.id) return true;
    }
    return false;
  }

  @Watch("searchQueryExecute")
  onSearchQueryChange() {
    TiendaOnlineClientesModule.getTiendaOnlineClientesesTodosPaginacion({
      skip: 0,
      take: this.productsPerPage,
      selectedProcessoNumber: this.selectedProcessoNum || 0,
      search: this.searchQuery,
    });
  }
}
